import {API} from "@/Composables/api";

const storeGroupMembers = async (group, params = {}) => {
    return API.post(route("admin.groups.members.add-members", group), params);
};

const storeMemberGroups = async (user, params = {}) => {
    return API.post(route("admin.groups.members.add-groups", user), params);
};

const removeGroupMember = async (group, member, params = {}) => {
    return API.delete(route("admin.groups.members.destroy", [group, member]), params);
};

export {storeGroupMembers, storeMemberGroups, removeGroupMember};
